import { FileText, Lock, Radio, SearchCheck } from "lucide-react";
import { Reveal } from "./Reveal";

const ITEMS = [
  {
    icon: Radio,
    title: "Multi-instrument detection",
    text: "Spectrum analysis, non-linear junction detection, thermal imaging and optical scanning, complementing one another.",
  },
  {
    icon: SearchCheck,
    title: "Physical search",
    text: "Fixtures, power points, ceilings and AV examined, and opened where that can be done without damage.",
  },
  {
    icon: FileText,
    title: "Written report",
    text: "A record written to be read by a board, not an engineer.",
  },
  {
    icon: Lock,
    title: "Confidential by default",
    text: "We do not publish client names, and attendance is arranged to avoid identifying the visit.",
  },
];

export default function CapabilityStrip() {
  return (
    <section className="border-y border-hairline" data-testid="capability-strip">
      <div className="grid grid-cols-1 gap-px bg-hairline sm:grid-cols-2 lg:grid-cols-4">
        {ITEMS.map(({ icon: Icon, title, text }, i) => (
          <div key={title} className="bg-base-color">
            <Reveal delay={i * 0.08} className="h-full">
              <div className="flex h-full flex-col gap-3 px-7 py-8" data-testid={`capability-${i + 1}`}>
                <Icon size={19} strokeWidth={1.6} className="text-violet" />
                <h3 className="font-head text-[0.9375rem] font-bold">{title}</h3>
                <p className="text-base leading-relaxed text-sub">{text}</p>
              </div>
            </Reveal>
          </div>
        ))}
      </div>
    </section>
  );
}
